import {useAuth} from '../../modules/auth'
import DashboardApiTableShow, {DashboardColumn} from './DashboardApiTableShow'
import {renderDashboardDateTwoLine, renderDashboardSku} from './dashboardFormatters'
import {useVerifyTokenOnClick} from './useVerifyTokenOnClick'

const columns: DashboardColumn<any>[] = [
  {header: 'Item SKU', sortKey: 'sku', render: (item) => renderDashboardSku(item.sku)},
  {header: 'SKU Description', sortKey: 'description', minWidth: 200, render: (item) => item.description || '-'},
  {
    header: 'Weighted Avg. Cost',
    sortKey: 'weighted_average_cost',
    width: 190,
    render: (item) => (item.weighted_average_cost ? `$${item.weighted_average_cost}` : '-'),
  },
  {header: 'Created', sortKey: 'created_at', width: 160, render: (item) => renderDashboardDateTwoLine(item.created_at)},
  {header: 'Updated', sortKey: 'updated_at', width: 160, render: (item) => renderDashboardDateTwoLine(item.updated_at)},
]

function TotalproductsShow() {
  const {currentUser} = useAuth()
  useVerifyTokenOnClick()

  return (
    <DashboardApiTableShow
      endpoint='GetAllProducts'
      title='Total Products'
      paginationTitle='Products'
      userTypeId={currentUser?.roles?.[0]?.id}
      columns={columns}
    />
  )
}

export default TotalproductsShow
